import BannersLink from '@components/BannersLink';
import './index.scss';
// import Picture from '@components/Picture';
import { Picture } from '@ui';
import icons from '@icons';
import ShareSocialLinksNew from '@components/ShareSocialLinksNew';
import LoadingSkeleton from '@components/LoadingSkeleton';

const {
  messageCircle: { midGrey: mcMGFilled }
} = icons.Fill;

export const ArticleCard = ({ item, className = '' }) => {
  const { title, attachmentsItem, id, seo_title } = item;

  return (
    <div className='article-card'>
      <div className='article-card__share'>
        <ShareSocialLinksNew
          offsetYDesktop={0}
          position={'bottom center'}
          link={`${location.origin}/lenta/${id}`}
        />
      </div>
      <BannersLink
        className={`article-card__wrapper ${className || ''}`}
        link={`/lenta/${id}`}
      >
        <div className='article-card__wrapper__img-wrapper'>
          {attachmentsItem?.cacheItem[0]?.filePath && (
            <img
              className='article-card__wrapper__img-wrapper__img'
              src={attachmentsItem.cacheItem[0].filePath}
              alt={seo_title || title}
            />
          )}
        </div>
        <div className='article-card__wrapper__info-wrapper'>
          {title && <div className='article-card__wrapper__title'>{title}</div>}
        </div>

        <div className='article-card__wrapper__comments-wrapper'>
          <Picture
            className='article-card__wrapper__comments-icon'
            icon={mcMGFilled}
            height='16'
            width='16'
          />
          {item?.commentsCount || 0}
        </div>
      </BannersLink>
    </div>
  );
};

export const ArticleCardLoading = () => (
  <div className='article-card'>
    <div className='article-card__wrapper'>
      <LoadingSkeleton className='article-card__wrapper__img-wrapper' />
      <div className='article-card__wrapper__info-wrapper'>
        <div className='article-card__wrapper__title'>
          <LoadingSkeleton className='h-[1lh] w-3/4' />
          <LoadingSkeleton className='h-[1lh] w-2/3' />
        </div>
      </div>
      <div className='article-card__wrapper__comments-wrapper'>
        <Picture
          className='article-card__wrapper__comments-icon'
          icon={mcMGFilled}
          height='16'
          width='16'
        />
        <LoadingSkeleton className='h-[1lh] w-[20px]' />
      </div>
    </div>
  </div>
);

// export default memo(ArticleCard);
